import React, { useState, useEffect, useCallback } from 'react';
import './ExchangeRateHistorySection.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const ExchangeRateHistorySection = () => {
  const [history, setHistory] = useState([]);

  const fetchHistory = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/exchange-rates/history`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setHistory(data);
      }
    } catch (err) {
      console.error('載入匯率歷史失敗', err);
    }
  }, []);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleString('zh-TW', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  };

  return (
    <section className="section exchange-rate-history-section">
      <div className="section-header">
        <h2>
          <span className="section-number">4</span>
          匯率更新歷史紀錄
        </h2>
      </div>
      <div className="history-table-container">
        {history.length === 0 ? (
          <div className="history-empty">尚無匯率更新紀錄</div>
        ) : (
          <table className="history-table">
            <thead>
              <tr>
                <th>更新日期</th>
                <th>幣別</th>
                <th>更新前</th>
                <th>更新後</th>
                <th>經手人</th>
              </tr>
            </thead>
            <tbody>
              {history.map((h) => (
                <tr key={h._id}>
                  <td>{formatDate(h.updatedAt)}</td>
                  <td>{h.label}</td>
                  <td>{h.oldRate}</td>
                  <td>{h.newRate}</td>
                  <td>{h.updatedBy?.name || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </section>
  );
};

export default ExchangeRateHistorySection;
